export const SKIP_LAYOUT_PATHS = ['/', '/login', '/two-factor', '/404'];
